var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 400H8C3.576 400 0 396.416 0 392V136C0 122.768 10.768 112 24 112C37.232 112 48 122.768 48 136V392C48 396.416 44.424 400 40 400ZM16 384H32V136C32 131.592 28.416 128 24 128C19.584 128 16 131.592 16 136V384Z",
    fill: "#0B2C3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M504 400H472C467.576 400 464 396.416 464 392V216C464 202.768 474.768 192 488 192C501.232 192 512 202.768 512 216V392C512 396.416 508.424 400 504 400ZM480 384H496V216C496 211.592 492.416 208 488 208C483.584 208 480 211.592 480 216V384Z",
    fill: "#0B2C3D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M472 360H40C35.576 360 32 356.416 32 352V272C32 267.584 35.576 264 40 264H152C156.424 264 160 267.584 160 272C160 276.416 156.424 280 152 280H48V344H464V272C464 267.584 467.576 264 472 264C476.424 264 480 267.584 480 272V352C480 356.416 476.424 360 472 360Z",
    fill: "#0B2C3D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M472 328H152C147.576 328 144 324.416 144 320V256C144 233.944 161.944 216 184 216H440C462.056 216 480 233.944 480 256V320C480 324.416 476.424 328 472 328ZM160 312H464V256C464 242.768 453.232 232 440 232H184C170.768 232 160 242.768 160 256V312Z",
    fill: "#0B2C3D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M152 280H40C35.576 280 32 276.416 32 272V240C32 217.944 49.944 200 72 200H120C142.056 200 160 217.944 160 240V272C160 276.416 156.424 280 152 280ZM48 264H144V240C144 226.768 133.232 216 120 216H72C58.768 216 48 226.768 48 240V264Z",
    fill: "#0B2C3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBed);
export default __webpack_public_path__ + "static/media/bed.9ef572097cddbe8adb593aa34187df0b.svg";
export { ForwardRef as ReactComponent };